export default {
    computed: {
        recentJobs() {
            return Object.values(this.$beet.jobs).sort((a, b) => new Date(b.publishedAt) - new Date(a.publishedAt))
        }
    }
}